/* eslint-disable lingui/no-unlocalized-strings -- rótulos técnicos das chamadas de fio (U27) */
import { creditApi } from '@/shared/http';
import { wire, withSignal } from '@/shared/reference/wire';
import {
  employeePositionsSchema,
  payrollAgreementListQueryParams,
  payrollAgreementPageSchema,
  payrollAgreementSchema,
  type PayrollAgreementListParams,
  type PayrollAgreementWrite,
} from './payroll-agreement.wire';
const path = (id: string) => `/PayrollAgreement/${encodeURIComponent(id)}`;
// U02: services/creditNote/payrollAgreement/payrollAgreement.ts:13–18; contexto:35–44.
export async function listPayrollAgreements(
  params: PayrollAgreementListParams,
  signal?: AbortSignal,
) {
  return wire(
    payrollAgreementPageSchema,
    await creditApi.get<unknown>('/PayrollAgreement', {
      params: payrollAgreementListQueryParams(params),
      ...withSignal(signal),
    }),
    'GET /PayrollAgreement',
  );
}
// U02: payrollAgreement.ts:20–25, sem tenant.
export async function getPayrollAgreement(id: string, signal?: AbortSignal) {
  return wire(
    payrollAgreementSchema,
    await creditApi.get<unknown>(path(id), withSignal(signal)),
    'GET /PayrollAgreement/{id}',
  );
}
// U02: payrollAgreement.ts:58–75; não filtra propriedades extras do GET.
export function createPayrollAgreement(body: PayrollAgreementWrite) {
  return creditApi.post('/PayrollAgreement', body);
}
export function updatePayrollAgreement(id: string, body: PayrollAgreementWrite) {
  return creditApi.put<unknown>(path(id), body);
}
// U02: payrollAgreement.ts:28–33.
export function deletePayrollAgreement(id: string) {
  return creditApi.delete<unknown>(path(id));
}
// U02: services/employeePositionCBO/index.ts:6–11; contexto inicial/fallback admin.
export async function listEmployeePositions(query = 'admin', signal?: AbortSignal) {
  const term = query.length >= 2 ? query : 'admin';
  return wire(
    employeePositionsSchema,
    await creditApi.get<unknown>(
      `/EmployeePositionCBO/${encodeURIComponent(term)}`,
      withSignal(signal),
    ),
    'GET /EmployeePositionCBO/{query}',
  );
}
